import { EApiOffersSortingId } from "utils/offer";
import { QueryValues } from "./queries";
export interface IOfferSortingItemConfig {
  translationId: string;
  queryValue: keyof (typeof QueryValues)["sorting"];
  apiId: EApiOffersSortingId;
}

export const OFFER_SORTING: Array<IOfferSortingItemConfig> = [
  {
    apiId: EApiOffersSortingId.BEST,
    translationId: "Nejlepší",
    queryValue: "offersSorting.best",
  },
  {
    apiId: EApiOffersSortingId.LATEST,
    translationId: "Nejnovější",
    queryValue: "offersSorting.latest",
  },
  {
    apiId: EApiOffersSortingId.CHEAPEST,
    translationId: "Nejlevnější",
    queryValue: "offersSorting.cheapest",
  },
];

export const OFFER_SORTING_MAP = new Map(
  OFFER_SORTING.map((item) => [item.queryValue, item]),
);

export const DEFAULT_OFFER_SORTING = OFFER_SORTING[1];
